export default {
	"refund.CopiedSuccessfully": "Copied successfully!",
	"refund.ReplicationIsNotSupported": "Replication is not supported",
	"refund.RefundSuccessfully": "Refund successfully",
	"refund.ParameterError": "Parameter error!",
	"refund.callOfficial": "call official",
	"refund.RefundInformation": "Refund Information",
	"refund.refundOrderNumber": "refund order number",
	"refund.copy": "copy",
	"refund.RefundType": "Refund Type",
	"refund.reasonForReturn": "reason for return",
	"refund.TotalAmountRefunded": "Total amount refunded",
	"refund.RefundInstructions": "Refund instructions"
}